function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Web",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Patient-Portal-Signed-In-//-Dashboard",
  transform: "translate(-1185.000000, -40.000000)",
  fill: "#B8C3D2",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-11",
  transform: "translate(1045.000000, 26.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "angle-down-regular-copy",
  transform: "translate(145.000000, 17.500000) rotate(-360.000000) translate(-145.000000, -17.500000) translate(140.000000, 14.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.7344165,5.89208896 L0.110139041,1.38833072 C-0.0367130136,1.24413682 -0.0367130136,1.01097223 0.110139041,0.866778333 L0.728792376,0.259323201 C0.875644431,0.115129307 1.11310733,0.115129307 1.25995938,0.259323201 L5,3.89485012 L8.74004062,0.259323201 C8.88689267,0.115129307 9.12435557,0.115129307 9.27120762,0.259323201 L9.88986096,0.866778333 C10.036713,1.01097223 10.036713,1.24413682 9.88986096,1.38833072 L5.2655835,5.89208896 C5.11873145,6.03628286 4.88126855,6.03628286 4.7344165,5.89208896 Z",
  id: "Path"
})))));

var SvgAngleDown = function SvgAngleDown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "7px",
    viewBox: "0 0 10 7",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAngleDown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/angle-down.6c2e69e2.svg";
export { ForwardRef as ReactComponent };